const localization = {
    cannot_delete_default_language: 'تم تعيين {{languageTag}} كلغة افتراضية ولا يمكن حذفها.',
    invalid_translation_structure: 'هياكل بيانات غير صالحة. يرجى التحقق من المدخلات الخاصة بك والمحاولة مرة أخرى.',
};
export default Object.freeze(localization);
